import { RecoilState, atom } from 'recoil';

import { ICommand } from 'client-types/*';

export interface IAttachment {
  id: string;
  serverId?: string;
  name: string;
  size: number;
  type: string;
  uploadProgress?: number;
  uploaded?: boolean;
  cancel?: () => void;
  remove?: () => void;
}

export const attachmentsState: RecoilState<IAttachment[]> = atom<IAttachment[]>({
  key: 'Attachments',
  default: []
});

export const persistentCommandState: RecoilState<ICommand | undefined> = atom<
  ICommand | undefined
>({
  key: 'PersistentCommand',
  default: undefined
});

export const webSearchEnabledState: RecoilState<boolean> = atom<boolean>({
  key: 'WebSearchEnabled',
  default: false
});

export const documentContextEnabledState: RecoilState<boolean> = atom<boolean>({
  key: 'DocumentContextEnabled',
  default: false
});

export const snowAttachmentFlowState: RecoilState<boolean> = atom<boolean>({
  key: 'SnowAttachmentFlow',
  default: false
});

export const uploadedDocumentNamesState: RecoilState<string[]> = atom<string[]>({
  key: 'UploadedDocumentNames',
  default: []
});

// Track which audio button is currently active (standard or assistant)
export const activeAudioButtonState: RecoilState<'standard' | 'assistant' | null> = atom<'standard' | 'assistant' | null>({
  key: 'ActiveAudioButton',
  default: null
});
